import "./FreshChatButton.scss"
import {useSelector} from "react-redux";
import {AppState} from "../RootReducer";
import {getLoggedIn} from "../selectors/user-selectors";
import {Route, Switch, useLocation} from "react-router-dom";
import * as React from "react";
import {useEffect, useState} from "react";
import {CHAT_CLOSED, CHAT_OPENED} from "./FreshChatWidget";
import { SportsbookProvider } from "../http/protocol";
import { getPathType } from "../onboardingpage/modalview/utils";

export const FreshChatButton = ( props : {gameView? : boolean}) => {
    const mobile  = useSelector((app : AppState) => app.settings.mobile);
    const showCashierModal  = useSelector((app : AppState) => app.payments.cashier && app.payments.cashier.showCashierModal);
    const sportsbookProvider = useSelector((app : AppState) => app.settings.settings?.sportsbookProvider)
    const loggedIn = useSelector((app : AppState) => getLoggedIn(app));
    const showMenuMobile  = useSelector((app : AppState) => app.user.displayMenuMobile);
    const showBalanceDropdown  = useSelector((app : AppState) => app.user.displayBalanceDropdown);
    const [chatOpened,setChatOpened] = useState(false);
    useEffect(() => {
        let listener = (ev : MessageEvent<string> ) => {
            if(ev.data === CHAT_OPENED) {
                setChatOpened(true);
            } else if(ev.data === CHAT_CLOSED) {
                setChatOpened(false);
            }
        };
        window.addEventListener("message", listener)
        return () => {
            window.removeEventListener("message", listener);
        }
    },[])

    if(chatOpened) {
        return <></>
    }

    const btn = <ChatButton loggedIn = {loggedIn} mobile = {mobile} cashierModal = {showCashierModal} showMenuMobile = {showMenuMobile} showBalanceDropdown = {showBalanceDropdown} />

    if (!mobile && props.gameView) {
        return btn
    }
    return (  
        <>
            <Switch>
                <Route exact path="/poker/play"></Route>
                <Route exact path="/casino/play/:gameId/:provider"></Route>
                <Route exact path="/casino/play/:gameId/:provider/:mode"></Route>
                <Route exact path="/sportsbook">
                    { sportsbookProvider != SportsbookProvider.ULTRAPLAY &&  btn }
                </Route>
                <Route path={"/"}>
                    { btn }
                </Route>
            </Switch>
        </>
    )
}


export const ChatButton = (props : { loggedIn : boolean, mobile?: boolean, cashierModal?: boolean, showMenuMobile?: boolean, showBalanceDropdown?: boolean }) => {
    const location = useLocation();
    const onClick = () => {
        if(window.fcWidget) {
            window.fcWidget.show();
            window.fcWidget.open();
        }
    }
    const modalclass = location && getPathType(location?.search as string);
    const showAccount = location.pathname && location.pathname.includes('/account/');
    return (
        <div className={"hide-in-context chat-button-wrapper " + (props.loggedIn ? "logged-in " : "") +  (props.mobile ? "mobile " : "") + (modalclass ? `${modalclass} ` : "") + (props.cashierModal ? "show-cashier " : "") +
        (props.showMenuMobile ? "show-menu-mobile " : "") + (props.showBalanceDropdown ? "show-balance " : "") + (showAccount ? "show-account " : "")}
        role="button" data-ember-action="" onClick={onClick}>
            <div className="icon"></div>
        </div>

    )
}